import { array, number, string } from 'yup'
import { object } from 'yup'

import {
  possibleDistributionListSports,
  possibleRecipientTypes
} from '@/constants/distributionList'

export const distributionRecipientFormValidationSchema = object().shape({
  emailAddress: string().email('Invalid email').required('Email is required'),
  recipientType: string()
    .oneOf(possibleRecipientTypes, 'Recipient type must be either ADMIN or OPERATOR')
    .required('Recipient type is required'),
  operatorId: number()
    .nullable()
    .when('recipientType', {
      is: 'OPERATOR',
      then: (schema) => schema.required('Operator is required for Operator recipient type'),
      otherwise: (schema) => schema.notRequired()
    }),
  sports: array()
    .of(string().oneOf(possibleDistributionListSports))
    .when('recipientType', {
      is: 'OPERATOR',
      then: (schema) =>
        schema.min(1, 'At least one sport must be selected for Operator recipient type'),
      otherwise: (schema) => schema.notRequired()
    })
})
